import Component from '@glimmer/component';
import { service } from '@ember/service';
import type RouterService from '@ember/routing/router-service';
import { t } from 'ember-intl';
import pageTitle from 'ember-page-title/helpers/page-title';
import { PhCurrencyCircleDollar } from 'ember-phosphor-icons';
import { VStack } from 'tio-ui/components/layout';
import PageHeader from 'tio-ui/components/page-header';
import PageHero from 'tio-ui/components/page-hero';

const INDEX_ROUTE = 'authenticated.idr.dashboard.index';

/**
 * Frame for the income-driven repayment area: the landing hero on the index
 * route, the detail-page header on the questionnaire, results and history
 * children that render through the outlet.
 */
export default class IdrDashboard extends Component {
  @service declare router: RouterService;

  get isIndex() {
    return this.router.currentRouteName === INDEX_ROUTE;
  }

  <template>
    {{pageTitle (t "idr.default")}}
    <VStack class="gap-8">
      {{#if this.isIndex}}
        <PageHero
          @title={{t "idr.default"}}
          @icon={{PhCurrencyCircleDollar}}
          @gradient="brand-soft"
          class="tio-elevation-card-raised"
        />
      {{else}}
        <PageHeader @title={{t "idr.default"}} />
      {{/if}}
      {{outlet}}
    </VStack>
  </template>
}
